import React from "react";
import { Box, Button, Dialog, DialogContent, Typography, useTheme } from "@mui/material";
import { MdWarning, MdLogout, MdClose } from "react-icons/md";

/**
 * LogoutConfirmationDialog - Asks the user if they want to discard changes
 * and logout when unsaved work is detected.
 */
const LogoutConfirmationDialog = ({ open, onConfirm, onCancel }) => {
    const theme = useTheme();

    return (
        <Dialog
            open={open}
            onClose={onCancel}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    padding: 1,
                    boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
                }
            }}
        >
            <DialogContent sx={{ textAlign: "center", pt: 4, pb: 4 }}>
                <Box
                    sx={{
                        width: 70,
                        height: 70,
                        borderRadius: "50%",
                        backgroundColor: `${theme.palette.error.main}15`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto 20px",
                    }}
                >
                    <MdWarning size={36} color={theme.palette.error.main} />
                </Box>

                <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: theme.palette.text.primary }}>
                    Unsaved Changes
                </Typography>

                <Typography variant="body1" sx={{ mb: 4, color: theme.palette.text.secondary, px: 2 }}>
                    You have unsaved work (in this or another tab) that will be lost if you log out. Do you want to continue?
                </Typography>

                <Box sx={{ display: "flex", gap: 2, px: 1 }}>
                    <Button
                        variant="outlined"
                        fullWidth
                        onClick={onCancel}
                        startIcon={<MdClose />}
                        sx={{
                            py: 1.5,
                            fontWeight: 600,
                            textTransform: "none",
                            borderRadius: 2,
                            borderColor: theme.palette.divider,
                            color: theme.palette.text.primary,
                            "&:hover": {
                                backgroundColor: theme.palette.action.hover,
                                borderColor: theme.palette.text.primary,
                            }
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        fullWidth
                        onClick={onConfirm}
                        startIcon={<MdLogout />}
                        sx={{
                            py: 1.5,
                            fontWeight: 600,
                            textTransform: "none",
                            borderRadius: 2,
                            backgroundColor: theme.palette.error.main,
                            "&:hover": {
                                backgroundColor: theme.palette.error.dark,
                            }
                        }}
                    >
                        Logout
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default LogoutConfirmationDialog;
